<template>
  <div class="aside-redes animated fadeInLeft delay-1s">
    <a  href="https://www.facebook.com/genaro.pretillescobar" target="_blank" class="facebook"><i class="fab fa-facebook-f"></i></a>
    <a href="https://twitter.com/gepres" target="_blank" class="twitter"><i class="fab fa-twitter"></i></a>
    <a href="https://www.instagram.com/gepres" target="_blank" class="instagram"><i class="fab fa-instagram"></i></a>
  </div>
</template>

<script>
  export default {
    name:'aside-redes',
    data(){
      return{

      }
    }
  }
</script>

<style lang="scss" scoped>
.aside-redes{
  display: flex;
  flex-direction: column;
  position: -webkit-sticky;
  position: sticky;
  top: 80px;
  @media screen and (max-width:900px){ 
    flex-direction: row;
    justify-content: center;
    width: 100%;
  }
  & a{
    font-size: 1.5rem;
    margin-bottom: 1rem;
    color:rgb(83, 87, 90);
    transition: transform 0.25s;
    @media screen and (max-width:900px){ 
    margin-right: 1.5rem;
    font-size: 1.7rem;
    }
  }
}
.facebook:hover{
color:#3B579C;
// transform: scale(1.2);
}
.twitter:hover{
  color:#5DA9DC;
}
.instagram:hover{
  color:#E1306C;
}
</style>